//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Navbar from "@/components/Navbar";
import CustomInAppInstall from "./components/CustomInAppInstall";
import appUpdate from "./mixins/appUpdate";
import { mapMutations, mapGetters, mapActions } from "vuex";
export default {
  name: "App",
  components: { Navbar, CustomInAppInstall },
  mixins: [appUpdate],
  data() {
    return {
      dlgInfo: false,
      dlgMessage: "",
      showSnackbar: false,
      snackbarMessage: "",
      snackbarColor: "orange darken-3",
    };
  },
  methods: {
    ...mapMutations(["setAppBusyAnimation", "setRandomisationMenuItem"]),
    ...mapActions([
      "clientIsOffline",
      "fetchRandomisationCount",
      "fetchCompletedPostRandCRFCount",
      "fetchUncompletedPostRandCRFCount",
    ]),
    async offlineRandomisationsUploadReminder() {
      const randsCount = await this.fetchRandomisationCount();
      const postRandCRFcount = await this.fetchCompletedPostRandCRFCount();
      const isOffline = await this.clientIsOffline();
      if ((randsCount > 0 || postRandCRFcount > 0) > 0 && !isOffline) {
        this.dlgMessage =
          "Please upload offline data. You may decide to do this later if you need to perform an urgent randomisation.";
        this.dlgInfo = true;
      }
    },
    async uncompletedPostRandCRFsReminder() {
      const uncompletedPostRandCRFcount =
        await this.fetchUncompletedPostRandCRFCount();
      if (uncompletedPostRandCRFcount > 0) {
        this.snackbarMessage = `<b>${uncompletedPostRandCRFcount}</b> Post-Rand-CRFs awaiting to be fully-completed.`;
        this.showSnackbar = true;
      }
    },
    closeInfoDialog() {
      this.dlgInfo = false;
    },
    proceedToUploadPage() {
      this.dlgInfo = false;
      if (this.$route.name != "sync-data") {
        this.$router.push("/sync-data");
      }
    },
    async onChangeNetworkStatus(e) {
      const { type } = e;
      if (type === "online") {
        await this.offlineRandomisationsUploadReminder();
        await this.uncompletedPostRandCRFsReminder();
      } else {
        await this.uncompletedPostRandCRFsReminder();
      }
    },
  },
  computed: {
    ...mapGetters(["getAppBusyAnimation"]),
  },
  async mounted() {
    this.setRandomisationMenuItem();
    await this.offlineRandomisationsUploadReminder();
    await this.uncompletedPostRandCRFsReminder();
    window.addEventListener("online", this.onChangeNetworkStatus);
    window.addEventListener("offline", this.onChangeNetworkStatus);
  },
};
